import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MutualModule } from '@shared/mutual/mutual.module';

import {
  ContainerEditComponent,
  ContainerEditModalComponent,
  ContainerLinkContainerItemComponent,
  ContainerLinkShipmentComponent,
  ContainerLinkShipmentItemComponent,
  ContainerListComponent,
  ContainerSingleShipmentComponent,
  ContainerViewComponent,
} from './components';
import { NgxPaginationModule } from 'ngx-pagination';
import { RouterModule } from '@angular/router';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';

@NgModule({
  declarations: [
    ContainerEditComponent,
    ContainerListComponent,
    ContainerViewComponent,
    ContainerSingleShipmentComponent,
    ContainerLinkShipmentComponent,
    ContainerLinkShipmentItemComponent,
    ContainerLinkContainerItemComponent,
    ContainerEditModalComponent,
  ],
  imports: [
    CommonModule,
    MutualModule,
    NgxPaginationModule,
    RouterModule,
    PipesSharedModule,
    FormWrapperModule,

    AccordionModule.forRoot(),
    DragDropModule,
  ],
  exports: [
    ContainerEditComponent,
    ContainerListComponent,
    ContainerViewComponent,
    ContainerSingleShipmentComponent,
    ContainerLinkShipmentComponent,
    ContainerEditModalComponent,
  ],
})
export class ContainersModule {}
